import MyService from '../../service';

const DesignApi = {
  getAllDesign: async () => {
    let result = null;

    await MyService.getRequestData('/vehicles/design')
      .then((res) => (result = res.data))
      .catch((err) => console.log(err));
    return result;
  },
};
export default DesignApi;
